"use client";

import React from "react";
import { cn } from "utils";
import { ReportScoreBreakdownProps } from "./XPayReportTypes";
import Translations from "@translate/components/Chat/Cards/ScoreBreakdown";
import { I18nUtil } from "@utils/i18n";
import { useIsPc } from "@hooks/useIsPc";
import FinalScore from "@components/FinalScore";

const I18n = I18nUtil.createScoped(Translations);

const ScoreBreakdown: React.FC<ReportScoreBreakdownProps> = ({ score }) => {
  const [isPC] = useIsPc();

  const finalScore = score?.score || "A+";
  const breakdown = score?.breakdown;

  if (!breakdown) {
    // 如果没有评分数据，仍然显示基础评分
    return (
      <div
        className={cn(
          "flex-shrink-0 flex items-center gap-6 max-md:gap-3 justify-between max-md:flex-col pl-7",
          "max-md:w-full max-md:pl-0 max-md:mt-4 max-md:flex-row max-md:gap-6",
        )}
      >
        <FinalScore
          score={finalScore}
          classNames={{
            container: isPC ? "gap-4" : "gap-3 flex-shrink-0",
            score: isPC ? "headline_regular_l" : "headline_regular_m",
            text: isPC ? "body_medium_m" : "body_medium_s",
          }}
          laurelWidth={isPC ? 28 : 15}
          laurelHeight={isPC ? 85 : 48}
        />
      </div>
    );
  }

  const breakdownItems = [
    {
      label: I18n.t("Fundamental"),
      key: "fundamental",
      value: breakdown.fundamental,
    },
    {
      label: I18n.t("Tokenomics"),
      key: "tokenomics",
      value: breakdown.tokenomics,
    },
    { label: I18n.t("Momentum"), key: "momentum", value: breakdown.momentum },
    {
      label: I18n.t("Valuation"),
      key: "valuation",
      value: breakdown.valuation,
    },
    { label: I18n.t("Growth"), key: "growth", value: breakdown.growth },
    {
      label: I18n.t("Competition"),
      key: "competition",
      value: breakdown.competition,
    },
  ].filter((item) => item.value); // 只显示有值的项目

  return (
    <div
      className={cn(
        "flex-shrink-0 flex items-center gap-6 max-md:gap-3 justify-between max-md:flex-col pl-7",
        "max-md:w-full max-md:pl-0 max-md:mt-4 max-md:flex-row max-md:gap-6",
      )}
    >
      <FinalScore
        score={finalScore}
        classNames={{
          container: isPC ? "gap-4" : "gap-3 flex-shrink-0",
          score: isPC ? "headline_regular_l" : "headline_regular_m",
          text: isPC ? "body_medium_m" : "body_medium_s",
        }}
        laurelWidth={isPC ? 28 : 15}
        laurelHeight={isPC ? 85 : 48}
      />

      {breakdownItems.length > 0 && (
        <div className="flex flex-col gap-2 max-md:w-full">
          {breakdownItems.map(({ label, key, value }) => (
            <div
              key={key}
              className="flex items-center justify-between flex gap-2"
            >
              <div className="body_s text-content_secondary">{label}</div>
              <div className="body_bold_s text-content_primary">{value}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ScoreBreakdown;
